import { Contract } from "../../customProvider/objects/contract";
import { PricingType } from "../objects/pricingType";
import { Room } from "../objects/room";
import { RoomPrice } from "../objects/roomPrice";
import { isSameDay, startOfDay, addDays } from 'date-fns';

export const getRoomPrices = (room: Room, contract_selected: Contract | null, pricing_type: PricingType | null, booking_type: 0 | 1): RoomPrice[] => {
    const room_prices: RoomPrice[] = [];
    (room as Room).prices.map((price) => {
        if (
            price.contract !== null &&
            price.contract === contract_selected?.id
        ) {
            const age_range_prices = price.age_range_prices.map((age_range_price) => ({
                ...age_range_price,
                pax_age_range: age_range_price.pax_age_range.map((age_range) => typeof age_range === 'object'? Number(age_range.id) : age_range),
                price: age_range_price.price ?? '',
                selling_price: age_range_price.selling_price ?? '',
                com_price: age_range_price.com_price ?? '',
                markup_price: age_range_price.markup_price ?? '',
            }));
            let added = false;
            room_prices.map((current_price) => {
                const is_same_selling_prices =
                    (price.double_selling_price === null
                        ? ""
                        : price.double_selling_price) ===
                    current_price.selling_double &&
                    (price.selling_extra_adult === null
                        ? ""
                        : price.selling_extra_adult) ===
                    current_price.selling_extra_adult &&
                    // (price.selling_extra_baby === null
                    //     ? ""
                    //     : price.selling_extra_baby) ===
                    // current_price.selling_extra_baby &&
                    // (price.selling_extra_child === null
                    //     ? ""
                    //     : price.selling_extra_child) ===
                    // current_price.selling_extra_infant &&
                    // (price.selling_extra_teen === null
                    //     ? ""
                    //     : price.selling_extra_teen) ===
                    // current_price.selling_extra_teen &&
                    (price.monoparent_selling_price === null
                        ? ""
                        : price.monoparent_selling_price) ===
                    current_price.selling_mono &&
                    (price.quad_selling_price === null
                        ? ""
                        : price.quad_selling_price) ===
                    current_price.selling_quad &&
                    (price.selling_single_price === null
                        ? ""
                        : price.selling_single_price) ===
                    current_price.selling_single &&
                    (price.triple_selling_price === null
                        ? ""
                        : price.triple_selling_price) ===
                    current_price.selling_triple;

                const is_same_purchase_prices =
                    (price.double_price === null
                        ? ""
                        : price.double_price) ===
                    current_price.double &&
                    // (price.extra_adult === null
                    //     ? ""
                    //     : price.extra_adult) ===
                    // current_price.extra_adult &&
                    // (price.extra_baby === null
                    //     ? ""
                    //     : price.extra_baby) ===
                    // current_price.extra_baby &&
                    // (price.extra_child === null
                    //     ? ""
                    //     : price.extra_child) ===
                    // current_price.extra_infant &&
                    // (price.extra_teen === null
                    //     ? ""
                    //     : price.extra_teen) ===
                    // current_price.extra_teen &&
                    (price.monoparent_price === null
                        ? ""
                        : price.monoparent_price) ===
                    current_price.mono &&
                    (price.quad_price === null
                        ? ""
                        : price.quad_price) === current_price.quad &&
                    (price.single_price === null
                        ? ""
                        : price.single_price) ===
                    current_price.single &&
                    (price.triple_price === null
                        ? ""
                        : price.triple_price) === current_price.triple;

                const is_same_com_prices =
                    (price.double_com_price === null
                        ? ""
                        : price.double_com_price) ===
                    current_price.com_double &&
                    // (price.com_extra_adult === null
                    //     ? ""
                    //     : price.com_extra_adult) ===
                    // current_price.com_extra_adult &&
                    // (price.com_extra_baby === null
                    //     ? ""
                    //     : price.com_extra_baby) ===
                    // current_price.com_extra_baby &&
                    // (price.com_extra_child === null
                    //     ? ""
                    //     : price.com_extra_child) ===
                    // current_price.com_extra_infant &&
                    // (price.com_extra_teen === null
                    //     ? ""
                    //     : price.com_extra_teen) ===
                    // current_price.com_extra_teen &&
                    (price.monoparent_com_price === null
                        ? ""
                        : price.monoparent_com_price) ===
                    current_price.com_mono &&
                    (price.quad_com_price === null
                        ? ""
                        : price.quad_com_price) === current_price.com_quad &&
                    (price.com_single_price === null
                        ? ""
                        : price.com_single_price) ===
                    current_price.com_single &&
                    (price.triple_com_price === null
                        ? ""
                        : price.triple_com_price) === current_price.com_triple;

                const is_same_markup_prices =
                    (price.double_markup_price === null
                        ? ""
                        : price.double_markup_price) ===
                    current_price.markup_double &&
                    // (price.markup_extra_adult === null
                    //     ? ""
                    //     : price.markup_extra_adult) ===
                    // current_price.markup_extra_adult &&
                    // (price.markup_extra_baby === null
                    //     ? ""
                    //     : price.markup_extra_baby) ===
                    // current_price.markup_extra_baby &&
                    // (price.markup_extra_child === null
                    //     ? ""
                    //     : price.markup_extra_child) ===
                    // current_price.markup_extra_infant &&
                    // (price.markup_extra_teen === null
                    //     ? ""
                    //     : price.markup_extra_teen) ===
                    // current_price.markup_extra_teen &&
                    (price.monoparent_markup_price === null
                        ? ""
                        : price.monoparent_markup_price) ===
                    current_price.markup_mono &&
                    (price.quad_markup_price === null
                        ? ""
                        : price.quad_markup_price) === current_price.markup_quad &&
                    (price.markup_single_price === null
                        ? ""
                        : price.markup_single_price) ===
                    current_price.markup_single &&
                    (price.triple_markup_price === null
                        ? ""
                        : price.triple_markup_price) === current_price.markup_triple;
                const current_age_range_prices = current_price.age_range_prices.map((age_range_price) => ({
                    ...age_range_price,
                    pax_age_range: age_range_price.pax_age_range.map((age_range) => typeof age_range === 'object'? Number(age_range.id) : age_range),
                    price: age_range_price.price ?? '',
                    selling_price: age_range_price.selling_price ?? '',
                    com_price: age_range_price.com_price ?? '',
                    markup_price: age_range_price.markup_price ?? '',
                }));
                const is_same_age_range_price =
                    JSON.stringify(age_range_prices.sort((a, b) => Number(a.pax_age_range[0] as number) - Number(b.pax_age_range[0] as number)))
                    ===  JSON.stringify(current_age_range_prices.sort((a, b) => Number(a.pax_age_range[0] as number) - Number(b.pax_age_range[0] as number)));

                if (
                    ((booking_type !== 0 && is_same_age_range_price) || booking_type === 0) &&
                    price.behavior_monoparent_adult ===
                    current_price.mono_adult &&
                    price.behavior_monoparent_child ===
                    current_price.mono_child &&
                    (
                        ((pricing_type === PricingType.PURCHASE) && is_same_purchase_prices) ||
                        ((pricing_type === PricingType.PURCHASE_COM) && is_same_purchase_prices && is_same_com_prices) ||
                        ((pricing_type === PricingType.PURCHASE_MARKUP) && is_same_purchase_prices && is_same_markup_prices) ||
                        ((pricing_type === PricingType.PURCHASE_DETAILED) && is_same_purchase_prices && is_same_com_prices && is_same_markup_prices) ||
                        ((pricing_type === PricingType.SELLING || pricing_type === PricingType.SELLING_TTC) && is_same_selling_prices) ||
                        ((pricing_type === PricingType.SELLING_COM || pricing_type === PricingType.SELLING_COM_TTC) && is_same_selling_prices && is_same_com_prices) ||
                        ((pricing_type === PricingType.SELLING_MARKUP || pricing_type === PricingType.SELLING_MARKUP_TTC) && is_same_selling_prices && is_same_markup_prices) ||
                        ((pricing_type === PricingType.SELLING_DETAILED || pricing_type === PricingType.SELLING_DETAILED_TTC) && is_same_purchase_prices && is_same_com_prices && is_same_markup_prices)
                    )
                ) {
                    // Calculer le stock pour ce prix
                    const stocksArr = price.stocks ?? [];
                    const realStocks = price.real_stock ?? [];
                    const startDate = price.start_date ? new Date(price.start_date) : null;

                    const price_total_stock = (() => {
                        if (stocksArr.length === 0) {
                            return 0;
                        }

                        let total = 0;
                        for (let index = 0; index < stocksArr.length; index++) {
                            const stockValue = stocksArr[index];
                            const dateForIndex = startDate ? addDays(startDate, index) : null;

                            const realEntry = dateForIndex && Array.isArray(realStocks)
                                ? realStocks.find((rs: any) => {
                                    try {
                                        const rsDate = rs.date ? startOfDay(new Date(rs.date)) : null;
                                        return rsDate && isSameDay(rsDate, startOfDay(dateForIndex)) && !rs?.for_user;
                                    } catch {
                                        return false;
                                    }
                                })
                                : undefined;

                            const useValue = (realEntry && typeof realEntry.quantity !== 'undefined')
                                ? Number(realEntry.quantity)
                                : Number(stockValue ?? 0);

                            total += (isNaN(useValue) ? 0 : useValue);
                        }

                        return total;
                    })();

                    current_price.periods.push({
                        days: price.days !== null ? price.days : [],
                        days_error: '',
                        end_date:
                            price.end_date !== null
                                ? new Date(price.end_date)
                                : null,
                        end_date_error: '',
                        id: price.id,
                        start_date:
                            price.start_date !== null
                                ? new Date(price.start_date)
                                : null,
                        start_date_error: ''
                    });                    // Ajouter le stock de cette période au total_stock
                    const safePrice = Number(price_total_stock);
                    current_price.total_stock = (current_price.total_stock ?? 0) + (isNaN(safePrice) ? 0 : safePrice);

                    added = true;
                }
            });
            if (!added) {                // calculer total_stock et initial_stock en une seule passe
                const stocksArr = price.stocks ?? [];
                const realStocks = price.real_stock ?? [];
                const startDate = price.start_date ? new Date(price.start_date) : null;

                const { total_stock, initial_stock } = (() => {
                    if (stocksArr.length === 0) {
                        // Pas de stocks définis, mais on peut quand même chercher un real_stock initial
                        if (startDate && Array.isArray(realStocks)) {
                            const realAtStart = realStocks.find((rs: any) => {
                                try {
                                    const rsDate = rs.date ? startOfDay(new Date(rs.date)) : null;
                                    return rsDate && isSameDay(rsDate, startOfDay(startDate)) && !rs?.for_user;
                                } catch {
                                    return false;
                                }
                            });
                            if (realAtStart && typeof realAtStart.quantity !== 'undefined') {
                                return { total_stock: 0, initial_stock: Number(realAtStart.quantity) };
                            }
                        }
                        return { total_stock: 0, initial_stock: 0 };
                    }

                    let total = 0;
                    let initial = 0;
                    for (let index = 0; index < stocksArr.length; index++) {
                        const stockValue = stocksArr[index];
                        const dateForIndex = startDate ? addDays(startDate, index) : null;

                        // Chercher une entrée real_stock correspondant à cette date (non for_user)
                        const realEntry = dateForIndex && Array.isArray(realStocks)
                            ? realStocks.find((rs: any) => {
                                try {
                                    const rsDate = rs.date ? startOfDay(new Date(rs.date)) : null;
                                    return rsDate && isSameDay(rsDate, startOfDay(dateForIndex)) && !rs?.for_user;
                                } catch {
                                    return false;
                                }
                            })
                            : undefined;

                        // real_stock prend la priorité sur stocks
                        const useValue = (realEntry && typeof realEntry.quantity !== 'undefined')
                            ? Number(realEntry.quantity)
                            : Number(stockValue ?? 0);

                        if (index === 0) {
                            initial = isNaN(useValue) ? 0 : useValue;
                        }

                        total += (isNaN(useValue) ? 0 : useValue);
                    }

                    return { total_stock: total, initial_stock: initial };
                })();

                room_prices.push({
                    periods: [
                        {
                            days: price.days !== null ? price.days : [],
                            days_error: '',
                            end_date:
                                price.end_date !== null
                                    ? new Date(price.end_date)
                                    : null,
                            end_date_error: '',
                            id: price.id,
                            start_date:
                                price.start_date !== null
                                    ? new Date(price.start_date)
                                    : null,
                            start_date_error: ''
                        }
                    ],
                    id: price.id,
                    total_stock: total_stock ?? 0,
                    stock: initial_stock,
                    stock_error: '',
                    restitution_days:
                        price.restitution_days !== null
                            ? parseInt(price.restitution_days as string)
                            : null,

                    // Purchase
                    single:
                        price.single_price !== null
                            ? price.single_price
                            : "",
                    single_price_error: '',
                    double:
                        price.double_price !== null
                            ? price.double_price
                            : "",

                    triple:
                        price.triple_price !== null
                            ? price.triple_price
                            : "",
                    quad:
                        price.quad_price !== null
                            ? price.quad_price
                            : "",
                    mono:
                        price.monoparent_price !== null
                            ? price.monoparent_price
                            : "",
                    extra_adult:
                        price.extra_adult !== null
                            ? price.extra_adult
                            : "",
                    extra_infant:
                        price.extra_child !== null
                            ? price.extra_child
                            : "",
                    extra_baby:
                        price.extra_baby !== null
                            ? price.extra_baby
                            : "",
                    extra_teen:
                        price.extra_teen !== null
                            ? price.extra_teen
                            : "",
                    price_adult: price.price_adult !== null
                        ? price.price_adult
                        : "",
                    price_teen: price.price_teen !== null
                        ? price.price_teen
                        : "",
                    price_baby: price.price_baby !== null
                        ? price.price_baby
                        : "",
                    price_child: price.price_child !== null
                        ? price.price_child
                        : "",

                    // sale
                    selling_single:
                        price.selling_single_price !== null
                            ? price.selling_single_price
                            : "",
                    selling_single_error: '',
                    selling_double:
                        price.double_selling_price !== null
                            ? price.double_selling_price
                            : "",
                    selling_double_error: '',
                    selling_triple:
                        price.triple_selling_price !== null
                            ? price.triple_selling_price
                            : "",
                    selling_triple_error: '',
                    selling_quad:
                        price.quad_selling_price !== null
                            ? price.quad_selling_price
                            : "",
                    selling_quad_error: '',
                    selling_mono:
                        price.monoparent_selling_price !== null
                            ? price.monoparent_selling_price
                            : "",
                    selling_mono_error: '',
                    selling_extra_adult:
                        price.selling_extra_adult !== null
                            ? price.selling_extra_adult
                            : "",
                    selling_extra_adult_error: '',
                    selling_extra_infant:
                        price.selling_extra_child !== null
                            ? price.selling_extra_child
                            : "",
                    selling_extra_infant_error: '',
                    selling_extra_baby:
                        price.selling_extra_baby !== null
                            ? price.selling_extra_baby
                            : "",
                    selling_extra_baby_error: '',
                    selling_extra_teen:
                        price.selling_extra_teen !== null
                            ? price.selling_extra_teen
                            : "",
                    selling_extra_teen_error: '',
                    selling_price_adult: price.selling_price_adult !== null
                        ? price.selling_price_adult
                        : "",
                    selling_price_adult_error: '',
                    selling_price_teen: price.selling_price_teen !== null
                        ? price.selling_price_teen
                        : "",
                    selling_price_teen_error: '',
                    selling_price_baby: price.selling_price_baby !== null
                        ? price.selling_price_baby
                        : "",
                    selling_price_baby_error: '',
                    selling_price_child: price.selling_price_child !== null
                        ? price.selling_price_child
                        : "",
                    selling_price_child_error: '',

                    // com
                    com_single:
                        price.com_single_price !== null
                            ? price.com_single_price
                            : "",
                    com_single_price_error: '',
                    com_double:
                        price.double_com_price !== null
                            ? price.double_com_price
                            : "",
                    com_triple:
                        price.triple_com_price !== null
                            ? price.triple_com_price
                            : "",
                    com_quad:
                        price.quad_com_price !== null
                            ? price.quad_com_price
                            : "",
                    com_mono:
                        price.monoparent_com_price !== null
                            ? price.monoparent_com_price
                            : "",
                    com_extra_adult:
                        price.com_extra_adult !== null
                            ? price.com_extra_adult
                            : "",
                    com_extra_infant:
                        price.com_extra_child !== null
                            ? price.com_extra_child
                            : "",
                    com_extra_baby:
                        price.com_extra_baby !== null
                            ? price.com_extra_baby
                            : "",
                    com_extra_teen:
                        price.com_extra_teen !== null
                            ? price.com_extra_teen
                            : "",
                    com_price_adult: price.com_price_adult !== null
                        ? price.com_price_adult
                        : "",
                    com_price_teen: price.com_price_teen !== null
                        ? price.com_price_teen
                        : "",
                    com_price_baby: price.com_price_baby !== null
                        ? price.com_price_baby
                        : "",
                    com_price_child: price.com_price_child !== null
                        ? price.com_price_child
                        : "",
                    // markup
                    markup_single:
                        price.markup_single_price !== null
                            ? price.markup_single_price
                            : "",
                    markup_single_price_error: '',
                    markup_double:
                        price.double_markup_price !== null
                            ? price.double_markup_price
                            : "",
                    markup_triple:
                        price.triple_markup_price !== null
                            ? price.triple_markup_price
                            : "",
                    markup_quad:
                        price.quad_markup_price !== null
                            ? price.quad_markup_price
                            : "",
                    markup_mono:
                        price.monoparent_markup_price !== null
                            ? price.monoparent_markup_price
                            : "",
                    markup_extra_adult:
                        price.markup_extra_adult !== null
                            ? price.markup_extra_adult
                            : "",
                    markup_extra_infant:
                        price.markup_extra_child !== null
                            ? price.markup_extra_child
                            : "",
                    markup_extra_baby:
                        price.markup_extra_baby !== null
                            ? price.markup_extra_baby
                            : "",
                    markup_extra_teen:
                        price.markup_extra_teen !== null
                            ? price.markup_extra_teen
                            : "",
                    markup_price_adult: price.markup_price_adult !== null
                        ? price.markup_price_adult
                        : "",
                    markup_price_teen: price.markup_price_teen !== null
                        ? price.markup_price_teen
                        : "",
                    markup_price_baby: price.markup_price_baby !== null
                        ? price.markup_price_baby
                        : "",
                    markup_price_child: price.markup_price_child !== null
                        ? price.markup_price_child
                        : "",

                    mono_adult: price.behavior_monoparent_adult,
                    mono_child: price.behavior_monoparent_child,
                    age_range_prices: age_range_prices
                });
            }
        }
    });

    return room_prices;
};